import { useState } from "react";
import { getFeeValue, getBraintreeFeeValue } from "./methods";

const useFee = (isBraintree: boolean = false) => {
  const [feeValue, setFeeValue] = useState<string>("");

  const feeGetter = isBraintree
    ? getBraintreeFeeValue(setFeeValue)
    : getFeeValue(setFeeValue);

  return [feeValue, feeGetter] as const;
};

export default useFee;
